import { create } from "zustand";

export const useStoreWorkspaces = create((set, get) => ({
  membershipRequests: [],
  pendingInvitations: [],
  workspaces: [],

  setWorkspaces: (data) =>
    set({
      membershipRequests: data?.membershipRequests,
      pendingInvitations: data?.pendingInvitations,
      workspaces: data?.workspaces,
    }),
}));
